export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAADwAQCdASoFAAYAAgA0JQBOjXAAWbWXUQAA/mFaWU/MgE0PsDU0ViOmu8t+tH9+/+DoAAAA"